import * as z from 'zod';
import { PhoneNumberUtil } from 'google-libphonenumber';
import i18next from 'i18next';

const phoneUtil = PhoneNumberUtil.getInstance();
// eslint-disable-next-line no-useless-escape

export const schema = z.object({
  firstName: z.string().trim().min(1, { message: i18next.t('First name required')}),
  lastName: z.string().trim().min(1,{ message: i18next.t('Last name required')}),
  email: z.string().trim().email({ message: i18next.t('Please enter a valid email address') }),
  phoneNumber: z
    .string()
    .trim()
    .nonempty({ message: i18next.t('Phone number cannot be empty') })
    .refine(
      (data) => {
        try {
          const number = phoneUtil.parse(data);
          return phoneUtil.isValidNumber(number);
        } catch {
          return false;
        }
      },
      { message: i18next.t('Please enter a valid phone number') }
    ),
});

type AppContactData = z.infer<typeof schema>;

export default AppContactData;
